export default {
    p: {
        urc: {
            title: '注册渠道',
            msg: {
                loadFailed: '注册渠道加载失败',
            },
            columns: {
                name: '渠道名称',
                code: '渠道码',
                userCount: '注册用户数',
                createdAt: '创建时间',
            },
        },
    },
};
